module.exports = __webpack_public_path__ + "assets/img/solar-panels-7.9b5b6053.jpg";